import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { notification } from 'antd';

import * as EventService from '../../../services/bb-api/event';
import { txt } from '../../../locales/i18n';
import { EventForm } from './form';

const initialEventValues = {
	status: 1,
	price: 0,
};

export const EventCreatePage = () => {
	const history = useHistory();

	const handleUpdateEvent = async (event: any) => {
		try {
			const eventId = await EventService.create(event);
			history.replace('/events/' + eventId);

			const message = txt('notification.create successful');
			notification.success({ message });
		} catch (error) {
			const message = txt('notification.create failed');
			notification.error({ message });
		}
	};

	return (
		<Main>
			<EventForm
				onSubmit={handleUpdateEvent}
				initialValues={initialEventValues}
				submitButtonText={txt('global.create')}
			/>
		</Main>
	);
};

const Main = styled.main`
	display: flex;
	justify-content: center;
`;
